export class User {
  public id!: string;
  public email!: string;
  public perfil!: string;
  public tecnico!: string;
  public nome!: string;
  public cliente!: string;
  public nomeCliente!: string;
  public telefone!: string;
  public cargo!: string;
}
